import NotFound from "../../components/NotFound";
import TopSideBar from "../../components/TopSideBar";
import Copyright from "../../components/common/Copyright";

export default function NotFoundPage() {
  return (
    <>
      <TopSideBar currentSection="" hideMenu hideUser hideProjectSelector />
      <NotFound />
      <Copyright />
    </>
  )
}